import styled from "@emotion/styled";
import {
    gutterSizes,
    mediaQuery,
    breakpoints,
    fontWeights,
    fontSizes,
    lineHeights,
    boxSizes,
    colors,
} from "@gumtree/ui-library/src/base/theme";
import Separator from "@gumtree/ui-library/src/separator/separator";

export const CreateOrderPageContainer = styled.div`
    margin: 0 auto;
    max-width: 1142px;
    padding: ${gutterSizes.xxlarge} 0;
    ${mediaQuery.until(breakpoints.medium)} {
        padding: ${gutterSizes.xxxxlarge} ${gutterSizes.base};
    }
`;

export const CreateOrderTitle = styled.h2`
    margin: 0 auto ${gutterSizes.xxlarge};
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.pgLarge};
    line-height: ${lineHeights.xlarge};
`;

export const OrderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: ${gutterSizes.xlarge};
    ${mediaQuery.until(breakpoints.medium)} {
        flex-direction: column-reverse;
    }
`;

export const OrderInfo = styled.div`
    flex: 1;
    .add-card-button {
        height: 48px;
        padding-left: ${gutterSizes.large};
        padding-right: ${gutterSizes.large20};
        border-radius: ${boxSizes.borderRadius4};
        font-weight: ${fontWeights.bold};
        text-align: center;

        .icon {
            font-size: ${fontSizes.small14};
            margin-right: ${gutterSizes.medium} !important;
        }
    }
`;

export const StyledSeparator = styled(Separator)`
    margin: ${gutterSizes.xxlarge} 0;
    ${mediaQuery.until(breakpoints.medium)} {
        margin: ${gutterSizes.xlarge} 0;
    }
`;

export const SubmitError = styled.p`
    &.submit-error-global {
        font-weight: ${fontWeights.bold};
    }
    font-weight: ${fontWeights.normal};
    font-size: ${fontSizes.small};
    line-height: ${lineHeights.small};
    color: #ff3a44;
    margin: 0 0 ${gutterSizes.medium} 0;
    ${mediaQuery.until(breakpoints.medium)} {
        margin: 0 0 ${gutterSizes.small} 0;
    }
`;

export const FormError = styled.p`
    font-family: Readex Pro;
    font-weight: 330;
    font-size: ${fontSizes.small};
    line-height: ${lineHeights.small};
    margin: ${gutterSizes.small} 0 0 0;
`;

export const TextBtn = styled.button<{ height?: number }>`
    height: ${({ height }) => (height ? `${height}px` : "auto")};
    width: fit-content;
    font-weight: 330;
    font-size: 15px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0px;
    color: ${colors.blue};
`;
